import { useDeviceContext } from '@/provider/DeviceProvider';

const [PC, MOBILE] = ['pc', 'mobile'];

// 自定义 Hook: useDeviceType
const useDeviceType = () => {
  const { deviceType } = useDeviceContext();
  return deviceType;
};

export { PC, MOBILE, useDeviceType };
